import request from '@/utils/request'

// 查询中国标准行业岗位列表
export function selectStandardIndustryApi () {
    return request({
        url: `/system/forward/system/follow/selectStandardIndustry`,
        method: 'post',
        headers: { repeatSubmit: false },
    })
}

//查询中国标准行业详细岗位列表
export function selectStandardIndustryJobApi () {
    return request({
        url: `/system/forward/system/follow/selectStandardIndustryJob`,
        method: 'post',
        headers: { repeatSubmit: false },
    })
}

//查询学生的基本信息
export function getStudentInfo (params) {
    return request({
        url: '/system/forward/system/student/detail/' + params,
        method: 'get'
    })
}

// 提交第一步
export function submitOne (data) {
    return request({
        url: `/system/my/employment/update/job/intention`,
        method: 'post',
        headers: { repeatSubmit: false },
        params: data
    })
}

// 第二步：获取学员达标情况-就业时间等信息
export function findStep2Time (data) {
    return request({
        url: `/system/my/employment/student/emp/info`,
        method: 'get',
        headers: { repeatSubmit: false },
        params: data
    })
}

// 第二步：获取学员就业版本
export function findStep2Version () {
    return request({
        url: `/system/my/employment/student/empStandard/version`,
        method: 'get',
        headers: { repeatSubmit: false },
    })
}

// 第二步：获取交付标准主信息
export function findStep2Main (standardVersionId) {
    return request({
        url: `/system/my/employment/student/empStandard/result`,
        method: 'get',
        headers: { repeatSubmit: false },
        params: {standardVersionId}
    })
}


// 第三步列表查询
export function findStep3 () {
    return request({
        url: `/system/employment/job/intention/getApplyList`,
        method: 'post',
        headers: { repeatSubmit: false },
        data: {}
    })
}

// 第三步单条详情查询
export function findStep3DetailOne (id) {
    return request({
        url: `/system/forward/system/employment/job/intention/query?id=${id}`,
        method: 'post',
        headers: { repeatSubmit: false },
    })
}

// 第三步单条新增/编辑
export function saveStep3 (data) {
    if (data.id) {
        return request({
            url: `/system/forward/system/employment/job/intention/edit`,
            method: "post",
            data,
        })
    }
    return request({
        url: `/system/forward/system/employment/job/intention/add`,
        method: "post",
        data: {
            ...data,
            source: 'pc'
        },
    })
}

// 第四步单条详情查询
export function getApplyListLastApi (data) {
    return request({
        url: `/system/employment/job/intention/getApplyListLast`,
        method: 'post',
        data,
        headers: { repeatSubmit: false },
    })
}


// 第四步 就业信息
export function jobinfoListApi (data) {
    return request({
        url: `/system/forward/system/employment/jobinfo/list`,
        method: 'post',
        data,
        headers: { repeatSubmit: false },
    })
}


// 查询对应协议数据
export function getApplyAgreementApi (data) {
    return request({
        url: `/system/employment/job/intention/getApplyAgreement`,
        method: 'post',
        data,
        headers: { repeatSubmit: false },
    })
}
